/**
 * Sort people alphabetically by personName
 */
export function sortPeople(items: Person[]): Person[] {
  return items.sort((a, b) => {
    const nameA = a.personName || '';
    const nameB = b.personName || '';
    return nameA.localeCompare(nameB);
  });
}

/**
 * Get a person by name with fuzzy matching
 * Handles variations in names (e.g., "Paul" vs "Paul the Apostle")
 */
export function getPersonByName(people: Person[], personName: string): Person | undefined {
  if (!personName) return undefined;

  const lowerName = personName.toLowerCase().trim();

  // 1. Try exact match
  let match = people.find(p => p.personName?.toLowerCase() === lowerName);
  if (match) return match;

  // 2. Try alternate names
  match = people.find(p =>
    p.alternateNames?.some(alt => alt?.toLowerCase() === lowerName)
  );
  if (match) return match;

  // 3. Try partial match (e.g., "Paul" matches "Paul the Apostle")
  match = people.find(p => {
    if (!p.personName) return false;
    const pName = p.personName.toLowerCase();
    return pName.includes(lowerName) || lowerName.includes(pName);
  });
  if (match) return match;

  // 4. Try alternate names with partial match
  match = people.find(p =>
    p.alternateNames?.some(alt => {
      if (!alt) return false;
      const altLower = alt.toLowerCase();
      return altLower.includes(lowerName) || lowerName.includes(altLower);
    })
  );

  return match;
}

